import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { BatchProcessDrawer } from "@/components/batch-process/batch-process-drawer";
import { BatchProcessLiveWidget } from "@/components/batch-process/batch-process-widget";
import { NewVersionToast } from "@/components/new-version-toast";
import { OrganizationGuard } from "@/components/organization-guard";
import { RouteNotFound } from "@/components/route-not-found";
import { toastActionClassName } from "@/lib/toast";

export interface MyRouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <OrganizationGuard>
      <Outlet />
      <BatchProcessLiveWidget />
      <BatchProcessDrawer />
      <div data-react-aria-top-layer="true">
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={{ classNames: { actionButton: toastActionClassName } }}
        />
      </div>
      <NewVersionToast />
    </OrganizationGuard>
  ),
  notFoundComponent: RouteNotFound,
});
